import BrutalCard from "@/components/common/BrutalCard";
import SectionHeading from "@/components/common/SectionHeading";
import { Quote } from "lucide-react";

const ITEMS = [
    {
        quote:
            "With Technovale’s AI-driven scheduling system, Samridhi Healthcare scaled from a single center to a multi-location diagnostic network in under a year. Our operational efficiency jumped by 40%, directly contributing to the 5x revenue growth we saw this fiscal year",
        name: "Manoj Kumar Upadhyay",
        role: "Director, Samridhi Healthcare",
        bg: "white",
    },
    {
        quote:
            "We needed to move from traditional walk-ins to a D2C lab-kit model overnight. Technovale didn't just build the platform; they built the entire logistics and tracking layer in 4 weeks. We scaled from 100 to 5,000+ monthly kit orders before our first expansion milestone. They don't just deliver code; they deliver market share.",
        name: "Jaskaran Sandhu",
        role: "Founder, Ameidic BioTech",
        bg: "pink",
    },
    {
        quote:
            "Working with Technovale is like having a tier-one engineering team on tap. They shipped our core engine with cleaner, more optimized code than our internal team could have produced in double the time. Their ability to solve complex algorithmic bottlenecks is what allowed us to scale so aggressively.",
        name: "Shubhansh Tiwari",
        role: "Partner, Welt Research Pvt Ltd.",
        bg: "yellow",
    },
];

export default function Testimonials() {
    return (
        <section
            data-testid="testimonials-section"
            className="border-b-4 border-ink py-24 md:py-32 bg-cream"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                <SectionHeading
                    eyebrow="Operators trust us"
                    title="Real teams. Real outcomes."
                />
                <div className="mt-14 grid md:grid-cols-3 gap-6">
                    {ITEMS.map((t, i) => (
                        <BrutalCard
                            key={i}
                            bg={t.bg}
                            className={i % 2 ? "md:translate-y-6" : ""}
                            data-testid={`testimonial-${i}`}
                        >
                            <Quote size={28} className="mb-4" />
                            <p className="font-display text-xl md:text-2xl font-bold leading-snug">
                                "{t.quote}"
                            </p>
                            <div className="mt-6 pt-5 border-t-2 border-ink/15">
                                <p className="font-display font-extrabold">{t.name}</p>
                                <p className="label-mono text-ink/60 mt-1">{t.role}</p>
                            </div>
                        </BrutalCard>
                    ))}
                </div>
            </div>
        </section>
    );
}
